import React from 'react';
import { useTranslation } from 'react-i18next';

const International = ({ content }) => {
  const { t } = useTranslation();
  
  return (
    <section id="international" className="py-20 bg-gray-50">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-12">
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-6">{t('international.title')}</h2>
            <p className="text-gray-600 text-lg mb-6">{t('international.description')}</p>
          </div>
          <div className="md:w-1/2">
            <div className="grid grid-cols-3 gap-4">
              {content.countries.map((country, index) => (
                <div key={index} className="flex flex-col items-center">
                  <img 
                    src={country.image} 
                    alt={country.name} 
                    className="w-16 h-16 object-contain mb-2"
                  />
                  <p className="text-center text-sm font-medium">{country.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default International;
